import * as Sentry from "@sentry/vue";

export function initSentry(app) {
    const loader = document.querySelector('script[src*="js.sentry-cdn.com"]');
    const dsn = import.meta.env.VITE_SENTRY_DSN
        || (loader ? undefined : document.querySelector('meta[name="sentry-dsn"]')?.content);

    if (!dsn) {
        return;
    }

    const configuredRate = import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE;

    Sentry.init({
        app,
        dsn,
        release: import.meta.env.SENTRY_RELEASE,
        environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: configuredRate ? Number(configuredRate) : 1.0,
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/(.*\.)?fruitfy\.io/,
            /^\//,
        ],
        sendDefaultPii: true,
    });
}
